// 新闻
export const NEWS = 'NEWS';

export const IS_SHOW_LOADING = 'IS_SHOW_LOADING';


// WEBPACK FOOTER //
// ./src/store/types.js